import { render, staticRenderFns } from "./SourceItem.vue?vue&type=template&id=5552a6fc"
import script from "./SourceItem.vue?vue&type=script&lang=js"
export * from "./SourceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports